import { DEFAULT_HOLD_SUBMIT_TIMEOUT_MS } from './config.js';

export const BB_COLLECT_STATUS = {
  NONE: 'none',
  OK: 'ok',
  ERROR: 'error',
  TIMEOUT: 'timeout',
};

const state = {
  enabled: true,
  auto: false,
  debugUi: false,
  apiHost: '',
  appId: '',
  holdSubmitTimeoutMs: DEFAULT_HOLD_SUBMIT_TIMEOUT_MS,
  lastCollectStatus: BB_COLLECT_STATUS.NONE,
  warnings: [],
};

export function setBbEnabled(enabled) {
  state.enabled = !!enabled;
}

export function setBbAuto(auto) {
  state.auto = !!auto;
}

export function setBbAppId(appId) {
  state.appId = appId ? String(appId) : '';
}

export function setBbDebugUi(enabled) {
  state.debugUi = !!enabled;
}

export function setBbApiHost(host) {
  state.apiHost = host ? String(host).replace(/\/?$/, '') : '';
}

export function setHoldSubmitTimeoutMs(timeoutMs) {
  state.holdSubmitTimeoutMs = timeoutMs;
}

export function addBbWarning(warning) {
  if (!state.warnings.includes(warning)) state.warnings.push(warning);
}

export function recordBbCollectResult(result) {
  const error = result && result.error ? String(result.error) : '';

  if (!error) {
    state.lastCollectStatus = BB_COLLECT_STATUS.OK;
    return;
  }

  state.lastCollectStatus =
    error.toLowerCase().indexOf('timeout') !== -1 ? BB_COLLECT_STATUS.TIMEOUT : BB_COLLECT_STATUS.ERROR;
}

/** @deprecated Use recordBbCollectResult */
export function recordBbSaveResult(result) {
  recordBbCollectResult(result);
}

export function recordBbCollectHoldTimeout() {
  state.lastCollectStatus = BB_COLLECT_STATUS.TIMEOUT;
  notifyBbDevToolsHoldTimeout();
}

/** @deprecated Use recordBbCollectHoldTimeout */
export function recordBbSaveHoldTimeout() {
  recordBbCollectHoldTimeout();
}

export function getBbIntegrationState() {
  return {
    enabled: state.enabled,
    auto: state.auto,
    debugUi: state.debugUi,
    apiHost: state.apiHost,
    appId: state.appId,
    holdSubmitTimeoutMs: state.holdSubmitTimeoutMs,
    lastCollectStatus: state.lastCollectStatus,
    /** @deprecated Use lastCollectStatus */
    lastSaveStatus: state.lastCollectStatus,
    /** @deprecated Modes removed; derived for DevTools compatibility */
    mode: state.auto ? 'auto' : 'manual',
    disabled: false,
    warnings: state.warnings.slice(),
  };
}

function notifyBbDevToolsHoldTimeout() {
  if (typeof __BB_DEVTOOLS__ === 'undefined' || !__BB_DEVTOOLS__) return;
  if (typeof window === 'undefined') return;

  const hook = window.__RS_BB_DEVTOOLS_SAVE_HOOK__;
  if (!hook || typeof hook.holdTimeout !== 'function') return;

  try {
    hook.holdTimeout();
  } catch (e) {
    /* devtools must not affect submit flow */
  }
}
